import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const UnverifiedBadge = () => {
    const { t } = useTranslation();

    return (
        <Typography
            variant="caption"
            sx={{
                color: '#fff',
                backgroundColor: 'var(--error-main)',
                padding: '2px 6px',
                borderRadius: '18px',
                width: 'fit-content',
                marginTop: '16px',
            }}
        >
            {t('common.unverified')}
        </Typography>
    );
};

export default UnverifiedBadge;
